<template>
    <section>
        <div class="page-header section-height-100">
            <div class="container">
                <div class="row">
                    <div class="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto p-3">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "AuthLayout",
    mounted() {
        document.body.style.backgroundImage = "url('" + process.env.VUE_APP_URL + "background.jpg')";
    },
    unmounted() {
        document.body.style.backgroundImage = "";
    },
};
</script>